import { useEffect, useState, useCallback } from "react";
import Breadcrumb from "../../Components/Breadcrumb";
import LoadingInComponent from "../../Components/LoadingInComponent";
import Button from "../../Components/Button";
import axios from "axios";
import { CREATE_TAG_API, GET_TAG_LIST_API } from "../../Constant/api";
import Modal from "../../Components/Modal";
import TextboxSet from "../../Components/TextboxSet";
import { useToast } from "../../Components/Toast";
import TagTable from "../../Components/Tables/TagTable";
import Can from "../../Components/Can";

const TagsList = () => {
  const breadcrumbItems = [
    {
      label: "Tag Management",
    },
    { label: "List" },
  ];
  const [loading, setLoading] = useState(false);
  const [tagList, setTagList] = useState(null);
  const [tagListMeta, setTagListMeta] = useState({});
  const [openAddPopup, setOpenAddPopup] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    color: "#5C4BF5",
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchCleared, setIsSearchCleared] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const { toast } = useToast();

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      fetchTagList();
    }
  };

  const clearFilter = () => {
    setSearchTerm("");
    setIsSearchCleared(true);
  };

  const handlePageClick = (e) => {
    fetchTagList(e.selected + 1);
  };

  const handlePerPageChange = (e) => {
    setPerPage(e.target.value);
    fetchTagList(1, e.target.value);
  };

  const fetchTagList = useCallback(async (page = 1, perPageValue = perPage) => {
    setLoading(true);
    axios
      .get(GET_TAG_LIST_API, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
        },
        params: {
          event_id: sessionStorage.getItem("event_id"),
          page: page,
          perPage: perPageValue,
          search: searchTerm,
        },
      })
      .then((res) => {
        setLoading(false);
        setTagList(res.data.data);
        setTagListMeta(res.data.meta.pagination);
      })
      .catch((err) => {
        setLoading(false);
        toast("Failed to fetch data", "error");
        console.log(err);
      });
  }, [perPage, searchTerm, toast]);

  const handleCreateTag = () => {
    setLoading(true);
    axios
      .post(
        CREATE_TAG_API,
        {
          event_id: sessionStorage.getItem("event_id"),
          name: formData.name,
          color: formData.color,
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
          },
        }
      )
      .then((res) => {
        setLoading(false);
        toast("Tag created successfully", "success");
        setOpenAddPopup(false);
        setFormData({
          name: "",
          color: "#000000",
        });
        fetchTagList();
      })
      .catch((err) => {
        setLoading(false);
        toast("Failed to create tag", "error");
        console.log(err);
      });
  };

  useEffect(() => {
    fetchTagList();
  }, [fetchTagList]);

  useEffect(() => {
    if (isSearchCleared && searchTerm === "") {
      fetchTagList();
      setIsSearchCleared(false);
    }
  }, [isSearchCleared, searchTerm, fetchTagList]);

  return (
    <div className="flex flex-col w-full h-full">
      
      {openAddPopup && (
        <Modal
          title="Add Tags"
          toggleModal={() => {
            setOpenAddPopup(!openAddPopup);
          }}
          submitLabel="Add Tag"
          handleSubmit={() => {
            handleCreateTag();
          }}
        >
          <div className="grid grid-cols-1 w-full gap-3">
            <TextboxSet
              type="text"
              name="name"
              value={formData.name}
              label="Name"
              required
              className="w-full"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  name: e.target.value,
                })
              }
            />
            <TextboxSet
              name="color"
              label="Tag Color"
              type="color"
              className="p-0 h-[40px] w-full"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  color: e.target.value,
                })
              }
              value={formData.color}
            />
          </div>
        </Modal>
      )}
      <LoadingInComponent isLoading={loading}>
        {!loading && (
          <div className="flex flex-col w-full h-full p-[16px] md:p-[32px] overflow-y-auto gap-[12px] md:gap-[24px]">
            <Breadcrumb items={breadcrumbItems} />
            {/* Title */}
            <div className="flex w-full items-center justify-between">
              <h1 className="text-[29px]">Tag Management</h1>
              <div className="flex items-center gap-2">
                {/* <Button variant="secondary">
                  <ExportSquare size="16" />
                  Export Report
                </Button> */}
                <Can permission="create_tag">
                <Button onClick={() => setOpenAddPopup(true)}>Add Tag</Button>
                </Can>
              </div>
            </div>

            {/* Data */}
            {tagList && (
              <TagTable
                data={tagList}
                meta={tagListMeta}
                searchTerm={searchTerm}
                handleSearch={handleSearch}
                handleKeyDown={handleKeyDown}
                clearFilter={clearFilter}
                editable
                handlePageClick={handlePageClick}
                perPage={perPage}
                handlePerPageChange={handlePerPageChange}
              />
            )}
          </div>
        )}
      </LoadingInComponent>
    </div>
  );
};

export default TagsList;
